import "./TheExpert.module.css";
import Header from "@/reusable_sections/Header";
import TheNovaPathStory from "./sections/TheNovaPathStory";
import PowerInMotion from "./sections/PowerInMotion";
import Footer from "@/reusable_sections/Footer";
export default function TheExpertPage() {
  return <div>
      <Header />
      <TheNovaPathStory />
      <PowerInMotion />
      <Footer />
    </div>;
}